import { __decorate } from "tslib";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CheckoutFormComponent } from './checkout-form.component';
import { ContactDetailsComponent } from './contact-details';
import { NumberPortingComponent } from './number-porting';
import { BankAccountComponent } from './bank-account';
import { TermsComponent } from './terms';
import { SharedModule } from '../../shared';
var CheckoutFormModule = /*@__PURE__*/ (function () {
    function CheckoutFormModule() {
    }
    return CheckoutFormModule;
}());
export { CheckoutFormModule };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/modules/checkout-form/checkout-form.module.ts
// module id = null
// module chunks = 